import React from "react";

import { IconSize } from "../../../enums";
import Input, { IInputProps } from "./Input";
import { WithPasswordInput, withPasswordInput } from "./withPasswordInput";

interface IProps extends IInputProps {

}

class PasswordInput extends React.PureComponent<IProps & WithPasswordInput> {
    render = () => {
        const Icon = this.props.password.icon;
        return (
            <Input {...this.props}
                   passRef={this.props.password.inputRef}
                   onIconClick={this.props.password.onIconClick}
                   type={this.props.isDisabled ? "password" : this.props.password.type}
                   icon={this.props.isDisabled ? null : <Icon width={IconSize.M}/>}
                   iconTitle={this.props.password.iconTitle}/>
        );
    };
}

export default withPasswordInput(PasswordInput);